import { FavoriteEntity } from "@backstage/plugin-catalog-react";
import { usePermission } from '@backstage/plugin-permission-react';
import { taskCreatePermission } from '@backstage/plugin-scaffolder-common/alpha';
import { Button, Card, CardActions, CardContent, Chip, IconButton, Tooltip, Typography } from "@material-ui/core";
import { Apps, Category, Code, FlashOn, Memory, Visibility, VpnKey } from "@material-ui/icons";
import React, { ComponentType } from "react";
import { useNavigate } from "react-router";
import { makeStyles } from "@material-ui/core";
import { TemplateType, getTemplateType } from "../../constants/templateTypes";

export const useStyles = makeStyles({
    card: {
        borderRadius: 8,
        padding: 0,
        border: '1px solid rgba(0,0,0,0.1)',
        transition: '0.2s',
    },
    typeContainer: {
        borderRadius: '8px',
        height: '100px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
    },
    iconTypeContainer: {
        display: 'flex',
        width: '48px',
        height: '48px',
        padding: 12,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        boxShadow: '0 2px 4px 0 rgba(51, 51, 51, 0.16)'
    },
    multilineEllipsis: {
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
    },
    title: {
        fontSize: 18
    },
    cardContent: {
        display: 'flex',
        padding: 16,
        paddingBottom: 0,
        flexDirection: 'column'
    },
    tagsContainer: {
        display: 'flex',
        gap: 4,
        marginTop: 16
    }
})

type Type = {
    icon: React.ReactNode,
    name: string,
    color: string

}

export const CustomCard: ComponentType<any> = ({ template, onSelected }) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const currentType = getTemplateType(template.spec.type);
    const typeMapping: Record<TemplateType, Type> = {
        "aplicacao": { color: '#ffb200', icon: <Apps />, name: 'Aplicação' },
        "servico": { color: '#36b3f6', icon: <Memory />, name: 'Serviço' },
        "api": { color: '#4fcd44', icon: <Code />, name: 'API' },
        "credencial": { color: '#5b299c', icon: <VpnKey />, name: 'Credenciais' },
        "outros": { color: '#424242', icon: <Category />, name: 'Outro' },
    }
    const color = typeMapping[currentType].color;
    const { allowed: canCreateTemplateTask } = usePermission({
        permission: taskCreatePermission,
    });

    return (
        <Card className={classes.card}>
            <CardContent style={{ padding: 0 }}>
                <div className={classes.typeContainer} style={{ backgroundColor: color + "10" }}>
                    <div className={classes.iconTypeContainer} style={{ backgroundColor: color }}>
                        <div style={{ color: "#FFF" }}>
                            {typeMapping[currentType].icon}
                        </div>
                    </div>
                </div>
                <div className={classes.cardContent}>
                    <div>
                        <Chip variant="outlined" size="small" style={{ borderColor: color, color }} label={currentType} />
                    </div>
                    <Typography variant="h6" gutterBottom className={classes.title}>
                        {template.metadata.title}
                    </Typography>
                    <Typography variant="body2" className={classes.multilineEllipsis}>
                        {template.metadata.description}
                    </Typography>
                    <div className={classes.tagsContainer}>
                        {(template.metadata.tags ?? []).map((tag: string) => <Chip size='small' label={tag} />)}
                    </div>
                </div>
            </CardContent>
            <CardActions style={{ justifyContent: 'space-between' }}>
                <Button startIcon={<FlashOn />} onClick={() => onSelected(template)} color='primary' disabled={!canCreateTemplateTask}>Escolher</Button>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <FavoriteEntity entity={template} />
                    <Tooltip title="Ver detalhes do template">
                        <IconButton
                            color="inherit"
                            size="small"
                            onClick={(e) => {
                                navigate(`/catalog/default/template/${template.metadata.name}`);
                            }}
                        >
                            <Visibility />
                        </IconButton>
                    </Tooltip>
                </div>
            </CardActions>
        </Card>
    );
};